import React from 'react';
import HelpContent from './HelpContent';
import preciosBaterias from 'img/precios_baterias.png';

const ElectromovilidadLivianoHelp = () => (
  <HelpContent>
    <h1>Electromovilidad en vehículos livianos</h1>
    <p>
      Se contempla el incremento de electromovilidad a partir del estándar de rendimiento vehicular, la prohibición de ventas de vehículos convencionales (a partir del año 2035) y la transformación de vehículos convencionales a vehículos eléctricos.
    </p>
    
    <p>
      <strong>Trayectoria 1:</strong> 
    </p>
    <p>    
      Vehiculos livianos: En 2030 el 11,4% del parque es eléctrico, 8% es reconvertido y 0,2% es híbrido. En 2040 el 46,5% del parque es eléctrico, 9,7% es reconvertido y 3,2% es híbrido. En 2050 el 81,2% del parque es eléctrico, 0% es reconvertido (chatarrizados en su totalidad) y 5,7% es híbrido.
    </p>
    <p> 
      Vehiculos medianos: En 2030 el 5% del parque es eléctrico y 0,8% es híbrido. En 2040 el 52,5% del parque es eléctrico y 1% es híbrido. En 2050 el 86% del parque es eléctrico y 1% es híbrido.
    </p>
    <p>
      <strong>Trayectoria 2:</strong> 
    </p>  
    <p>
      Vehiculos livianos: En 2030 el 11,4% del parque es eléctrico, 8% es reconvertido y 0,2% es híbrido. En 2040 el 51,8% del parque es eléctrico, 15,6% es reconvertido y 3,2% es híbrido. En 2050 el 85,5% del parque es eléctrico, 1,5% es reconvertido y 5,7% es híbrido.
    </p>
    <p>
      Vehiculos medianos: En 2030 el 5% del parque es eléctrico y 0,8% es híbrido. En 2040 el 54,4% del parque es eléctrico y 1% es híbrido. En 2050 el 95,5% del parque es eléctrico y 1% es híbrido.
    </p>  





  </HelpContent>
);

export default ElectromovilidadLivianoHelp;
